import { SelectableCard as DesignV2SelectableCard } from "../../design-v2";
import OptionGlyph from "../../components/product/optionGlyphs";

// Settings keeps `aria-pressed` (the canonical toggle selection mode) rather
// than radio semantics so the existing interaction model is unchanged.
export default function SelectableCard({
  label,
  description,
  icon,
  selected,
  onClick,
  disabled = false,
  tone = "default",
}) {
  return (
    <DesignV2SelectableCard
      title={label}
      description={description}
      leading={
        icon ? <OptionGlyph name={icon} /> : null
      }
      selected={Boolean(selected)}
      selectionMode="toggle"
      disabled={disabled}
      onClick={onClick}
      className={tone === "warning" ? "lz-settings-selectable-card--warning" : undefined}
    />
  );
}
